import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useApp } from '../contexts/AppContext';
import { checklists } from '../data/checklists';
interface ChecklistsProps {
  onChecklistSelect: (checklistId: string) => void;
}
export function Checklists({
  onChecklistSelect
}: ChecklistsProps) {
  const {
    colors
  } = useTheme();
  const {
    currentWard
  } = useApp();
  const wardChecklists = checklists.filter(checklist => checklist.ward === currentWard);
  return <div className="space-y-4" data-id="element-98">
      <h2 className="text-xl font-bold" data-id="element-99">Checklists</h2>
      {wardChecklists.length === 0 ? <p className="opacity-70" data-id="element-100">No checklists available for this ward.</p> : <div className="space-y-3" data-id="element-101">
          {wardChecklists.map(checklist => <button key={checklist.id} onClick={() => onChecklistSelect(checklist.id)} className="w-full p-4 rounded-lg text-left" style={{
        backgroundColor: colors.cardSurface
      }} data-id="element-102">
              <h3 className="font-bold" data-id="element-103">{checklist.title}</h3>
              <p className="text-sm opacity-70 mt-1" data-id="element-104">
                {checklist.steps.length} steps
              </p>
            </button>)}
        </div>}
    </div>;
}